import React, {Component} from "react";
import PropTypes from 'prop-types';
import { Chart, BarController, BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend } from 'chart.js'; 
import { wrapLabel } from "./wrapLabel";

Chart.register(BarElement,BarController, CategoryScale, LinearScale, Title, Tooltip, Legend);

class BarChartComponent extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
        this.chart = null;
    }

    buildChart = () => {
        const myChartRef = this.chartRef.current.getContext("2d");
        this.chart = new Chart(myChartRef, {
            type: "bar",
            data: {
                labels: this.props.labels,
                datasets: [
                    {
                        label: this.props.label,
                        data: this.props.data,
                        backgroundColor: this.props.backgroundColors,
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                aspectRatio: 1,
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: true
                    }
                },
                hover: {
                    onHover: function (e) {
                      var point = this.getElementsAtEventForMode(e, 'nearest', { intersect: true });
                      if (point.length) e.target.style.cursor = 'pointer';
                      else e.target.style.cursor = 'default';
                    },
                  },
                  scales: {
                    y: {
                      ticks: {
                        beginAtZero: true,
                      },
                    },
                    x: {
                      ticks: {
                        callback: function(value, index) {
                          const labelValue = this.chart.data.labels[index];
                          return wrapLabel(String(labelValue), 15); 
                        },
                      },
                    },
                }
            },
        });
        if (this.chartRef.current) {
          this.chartRef.current.__chartInstance = this.chart;
        }
    };

    componentDidMount() {
        this.buildChart();
    }

    componentDidUpdate() {
        if (this.chart) {
            this.chart.data.labels = this.props.labels;
            this.chart.data.datasets = [
                {
                    label: this.props.label,
                    data: this.props.data,
                    backgroundColor: this.props.backgroundColors,
                },
            ];
            this.chart.update();
        }
    }

    chartClick = (evt) => {
        if (!this.chart) return;
        
        const points = this.chart.getElementsAtEventForMode(
            evt, 
            'nearest', 
            { intersect: true }, 
            false
        );
        
        if (points.length) {
            const firstPoint = points[0];
            const label = this.chart.data.labels[firstPoint.index];
            const value = this.chart.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];
            
            this.props.legendCallBack(evt, {text: label, value});
        }
    };

    componentWillUnmount() {
        if (this.chart) {
            this.chart.destroy();
        }
    }

    render() {
        return (
            <canvas ref={this.chartRef} onClick={this.chartClick}/>
        );
    }
}

BarChartComponent.propTypes = {
    label: PropTypes.string.isRequired,
    labels: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    backgroundColors: PropTypes.array.isRequired,
    legendCallBack: PropTypes.func.isRequired
}

export const BarChart = BarChartComponent;